<template>
	<v-app>
		<NavView>
		</NavView>
		<v-main app>
			<v-container>
			<v-row>
				<v-col cols="12" lg="3">
					<v-card class="ma-3 ma-sm-5">
						<v-card-title @click="toggleUserInfo" class="d-flex justify-space-between" style="cursor:pointer;">
							个人信息
							<v-icon v-if="$vuetify.breakpoint.xsOnly">{{ userInfoOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
						</v-card-title>
						<v-card-text v-show="!$vuetify.breakpoint.xsOnly || userInfoOpen">
							<v-text-field v-model="user.loginName" label="登录名" outlined dense></v-text-field>
							<v-text-field v-model="user.name" label="名字" outlined dense></v-text-field>
							<v-text-field v-model="user.mobile" label="手机" outlined dense></v-text-field>
							<v-text-field v-model="user.email" label="email" outlined dense></v-text-field>
							<v-text-field v-model="user.country" label="国家" outlined dense></v-text-field>
							<v-text-field v-model="user.city" label="城市" outlined dense></v-text-field>
							<v-text-field v-model="user.address" label="详细地址" outlined dense></v-text-field>
						</v-card-text>
						<v-card-actions v-show="!$vuetify.breakpoint.xsOnly || userInfoOpen" class="align-center user-actions"><v-spacer class="hidden-xs-only"></v-spacer>
							<v-btn color="primary" class="user-btn" @click="save">保存</v-btn>
							<v-btn class="user-btn" @click="resetPasswordDivShow=true;">重置密码</v-btn>
							<v-spacer class="hidden-xs-only"></v-spacer>
						</v-card-actions>
					</v-card>
					<v-card class="ma-3 ma-sm-5">
						<v-card-title>微信绑定</v-card-title>
						<v-card-text>
							<div v-if="wxBound">
								<v-icon color="success">mdi-check-circle</v-icon>
								<span class="ml-2">已绑定微信，微信内访问将自动登录</span>
							</div>
							<div v-else>
								<v-icon color="grey">mdi-wechat</v-icon>
								<span class="ml-2">未绑定微信</span>
							</div>
						</v-card-text>
						<v-card-actions class="align-center user-actions"><v-spacer class="hidden-xs-only"></v-spacer>
							<v-btn v-if="!wxBound" color="primary" class="user-btn" @click="bindWechat" :loading="binding">立即绑定</v-btn>
							<v-btn v-if="wxBound" color="warning" class="user-btn" @click="unbindWechat" :loading="binding">解除绑定</v-btn>
							<v-spacer class="hidden-xs-only"></v-spacer>
						</v-card-actions>
					</v-card>
					<v-card class="ma-3 ma-sm-5">
						<v-card-title>账号</v-card-title>
						<v-card-actions class="align-center user-actions"><v-spacer class="hidden-xs-only"></v-spacer>
							<v-btn v-if="isAdmin" color="primary" class="user-btn" @click="changePage('/admin')">系统管理</v-btn>
							<v-btn color="error" class="user-btn" @click="logout">退出登录</v-btn>
							<v-spacer class="hidden-xs-only"></v-spacer>
						</v-card-actions>
					</v-card>
				</v-col>
				<v-col cols="12" lg="6">
					<v-card class="ma-3 ma-sm-5">
						<v-card-title>最近操作</v-card-title>
						<v-card-text>
						</v-card-text>
						<v-card-actions class="align-center">
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
			</v-container>
			<v-dialog v-model="resetPasswordDivShow" max-width="500px">
				<v-card>
					<v-card-title>修改密码</v-card-title>
					<v-card-text>
						<v-text-field v-model="password.new" label="新密码" outlined dense></v-text-field>
						<v-text-field v-model="password.newCheck" label="重复新密码" outlined dense></v-text-field>
						<div style="color:chocolate;">{{changePasswordMsg}}</div>
					</v-card-text>
					<v-card-actions class="align-center"><v-spacer></v-spacer>
						<v-btn @click="changePassword">保存</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog v-model="msgDialog" max-width="500">
				<v-card>
					<v-card-title>提示</v-card-title>
					<v-card-text>
						{{msg}}
					</v-card-text>
					<v-card-actions class="align-center"><v-spacer></v-spacer>
						<v-btn @click="msgDialog=false;">关闭</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-main>
	</v-app>
</template>

<script>
	import NavView from "./../components/NavBar";
	export default {
		name: 'QuotationView',
		components: {
			NavView,
		},

		data: () => ({
			activeTab: 0,
			userInfoOpen: false,
			user: {
				loginName: null,
				name: null,
				mobile: null,
				email: null,
				password: null,
				venderIdString: null,
				country: null,
				city: null,
				address: null
			},
			resetPasswordDivShow: false,
			password: {
				old: null,
				new: null,
				newCheck: null
			},
			msgDialog: false,
			msg: null,
			changePasswordMsg: null,
			wxBound: false,
			binding: false,
			isAdmin: false
		}),

		watch: {

		},
		created() {
			this.getUserDetail();
			this.getWxStatus();
			//管理员判断（与 NavBar 一致）
			let menu = JSON.parse(localStorage.getItem("menu"));
			if (menu) {
				menu.forEach(item => {
					if (item.funcLangCode === "用户管理") {
						this.isAdmin = true;
					}
				})
			}
			//微信绑定回调提示
			const wxBind = this.$route.query.wxBind;
			if (wxBind) {
				this.msg = this.$route.query.msg || (wxBind == '1' ? '绑定成功' : '绑定失败');
				this.msgDialog = true;
			}
		},
		methods: {
			changePage(url) {
				this.$router.push(url);
			},
			logout() {
				this.$axios.post('/kt-supplier/logout').then(res => {
					if (res.data.state == 200) {
						localStorage.removeItem('authToken');
						localStorage.removeItem("venderId");
						this.$router.push('/login');
					}
				});
			},
			toggleUserInfo() {
				if (this.$vuetify.breakpoint.xsOnly) {
					this.userInfoOpen = !this.userInfoOpen;
				}
			},
			getWxStatus() {
				this.$axios.post(this.serverUrl + "/wechat/status").then(res => {
					if (res.data.state == 200 && res.data.data != null) {
						this.wxBound = res.data.data.bound;
					}
				})
			},
			bindWechat() {
				this.binding = true;
				this.$axios.post(this.serverUrl + "/wechat/bindUrl").then(res => {
					this.binding = false;
					if (res.data.state == 200) {
						if (res.data.data) {
							//跳转微信授权页
							window.location.href = res.data.data;
						} else {
							//已绑定或无链接
							this.msg = res.data.msg || '生成绑定链接失败';
							this.msgDialog = true;
							this.getWxStatus();
						}
					} else {
						this.msg = res.data.msg || '生成绑定链接失败';
						this.msgDialog = true;
					}
				}).catch(() => {
					this.binding = false;
					this.msg = '生成绑定链接失败';
					this.msgDialog = true;
				});
			},
			unbindWechat() {
				if (!confirm('确定解除微信绑定？')) return;
				this.binding = true;
				this.$axios.post(this.serverUrl + "/wechat/unbind").then(res => {
					this.binding = false;
					if (res.data.state == 200) {
						this.wxBound = false;
						this.msg = '解绑成功';
						this.msgDialog = true;
					} else {
						this.msg = res.data.msg || '解绑失败';
						this.msgDialog = true;
					}
				}).catch(() => {
					this.binding = false;
					this.msg = '解绑失败';
					this.msgDialog = true;
				});
			},
			getUserDetail() {
				this.$axios.post(this.serverUrl + "/user/details").then(res => {
					if (res.data.state == 200 && res.data.data != null) {
						this.user = res.data.data;
					}
				})
			},
			save() {
				this.$axios.post(this.serverUrl + "/user/update", this.user).then(res => {
					if (res.data.state == 200 && res.data.data != null) {
						this.user = res.data.data;
						this.msg = res.data.msg;
						this.msgDialog = true;
					} else {
						this.msg = res.data.msg;
						this.msgDialog = true;
					}
				})
			},
			changePassword() {
				this.changePasswordMsg = " ";
				this.$axios.post(this.serverUrl + "/user/password", {
					user: {
						password: this.password.new
					}
				}).then(res => {
					if (res.data.state == 200) {
						this.changePasswordMsg = "修改成功";
					} else {
						this.changePasswordMsg = res.data.msg;
					}
				})
			}
		}
	}
</script>

<style>
	@media (max-width: 599px) {
		.user-actions {
			flex-wrap: wrap;
		}
		.user-btn {
			width: 100%;
			margin-left: 0 !important;
			margin-right: 0 !important;
			margin-bottom: 8px;
		}
		.user-btn:last-child {
			margin-bottom: 0;
		}
		.v-dialog {
			margin: 12px;
		}
	}
</style>